import { Action, createReducer, on } from '@ngrx/store';
import { IBusinessPaymentRunResponse } from '../dto/business-payment-run.dto';
import * as actions from '../actions';

export const businessPaymentRunFeatureKey = 'businessPaymentRun';

export interface BusinessPaymentRunState {
  loadBusinessPaymentRun: any;
  loadBusinessPaymentRunSuccess: IBusinessPaymentRunResponse;
}

export const initialState: BusinessPaymentRunState = {
  loadBusinessPaymentRun: undefined,
  loadBusinessPaymentRunSuccess: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadBusinessPaymentRuns, (state, action) => ({
    ...state,
    loadBusinessPaymentRun: action.request
  })),
  on(actions.loadBusinessPaymentRunsSuccess, (state, action) => ({
    ...state,
    loadBusinessPaymentRunSuccess: action.response
  }))
);

export const getBusinessPaymentRun = (state: BusinessPaymentRunState) => state.loadBusinessPaymentRunSuccess;
